<!-- 注册框组件 -->
<template>
	<div class="registeritem">
		<div class="registerbox">
			<div class="registerbox_FF">
				<div class="registerbox_item">
					<div class="title">用户注册</div>
					<div class="item">
						<input type="number" v-model.lazy="userno" placeholder="请输入您的学号" />
					</div>
					<div class="item password2">
						<input type="password" v-model.lazy="password1" placeholder="请输密码" />
						<img src="../../assets/images/yj.png" />
					</div>
					<div class="item password2">
						<input type="password" v-model.lazy="password2" placeholder="请确认密码" />
						<img src="../../assets/images/yj.png" />
					</div>
					<div class="items">
						<div class="item2">
							<select v-model.lazy="schoolid" @change="Setschool">
								<option value=null>选择学院</option>
								<option v-for="item in schoolList" :value="item.id">{{item.name}}</option>
							</select>
							<img class="jt" src="../../assets/images/jt.png" />
						</div>
						<div class="item2">
							<select v-model.lazy="majorid" @change="Setmajor">
								<option value=null>选择专业</option>
								<option v-if="majorList!=null" v-for="item in majorList.children" :value="item.id">
									{{item.name}}</option>
							</select>
							<img class="jt" src="../../assets/images/jt.png" />
						</div>
					</div>
					<div class="items">
						<div class="item2">
							<select v-model.lazy="classid">
								<option value=null>选择班级</option>
								<option v-if="classList!=null" v-for="item in classList.children" :value="item.id">
									{{item.name}}</option>
							</select>
							<img class="jt" src="../../assets/images/jt.png" />
						</div>
						<div class="item2">
							<input type="text" v-model.lazy="username" placeholder="填写真实姓名" />
						</div>
					</div>
					<div class="item">
						<select v-model.lazy="questionid">
							<option value=null>选择安全问题</option>
							<option v-if="questionList!=null" v-for="item in questionList" :value="item.id">
								{{item.name}}</option>
						</select>
						<img class="jt" src="../../assets/images/jt.png" />
					</div>
					<div class="item">
						<input type="text" v-model.lazy="questionanswer" placeholder="请输入安全问题答案" />
					</div>
					<div class="itembtn">
						<button @click="submit">提交注册</button>
						<a href="javascript:void(0);" @click="backlogin">返回登录</a>
					</div>
				</div>
			</div>
			<img class="rebag" src="../../assets/images/rebag.png" />
		</div>
		<!-- <popup ref="popup" :types="popuptype" :message="registermessage"></popup> -->
		<div class="popuptos" v-if="isshowinsertbox">
			<div class="popubox">
				<div class="poputitle">提示</div>
				<div class="poputext">
					注册成功，后台将在48小时内完成审核，请耐心等待...
				</div>
				<div class="btna">
					<a href="javascript:void(0);" @click="$router.back()">确定</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import popup from '../popups/popup.vue'
	export default {
		name: 'Registeritem',
		components:{
			popup
		},
		data() {
			return {
				popuptype: null,
				loginmessage:null,
				userno: null,
				password1: null,
				password2: null,
				schoolList: null, //学院
				majorList: null, //专业
				classList: null, //班级
				schoolid: null, //学院ID
				majorid: null, //专业ID
				classid: null, //班级ID
				questionList: null, //问题列表
				questionid: null, //问题id
				questionanswer: null, //问题答案
				username: null, //用户真实姓名
				registermessage: null, //注册提示信息
				isshowinsertbox: false
			}
		},
		created() {
			this.getSchoollist()
			this.getQuestionlist()
		},
		methods: {
			submit() {
				let issubmit = false
				if (this.userno == null || this.userno == '') {
					this.registermessage = '请输入学号'
					this.popuptype = 'warning'
					issubmit = false
				} else if (this.password1 == null || this.password1 == '') {
					this.registermessage = '请输入密码'
					this.popuptype = 'warning'
					issubmit = false
				} else if (this.password2 == null || this.password2 == '') {
					this.registermessage = '请输入密码'
					this.popuptype = 'warning'
					issubmit = false
				} else if (this.password1 != this.password2) {
					this.registermessage = '两次密码不匹配'
					this.popuptype = 'warning'
					issubmit = false
				} else if (this.schoolid == null || this.schoolid == '') {
					this.registermessage = '请选择学院'
					this.popuptype = 'warning'
					issubmit = false
				} else if (this.majorid == null || this.majorid == '') {
					this.registermessage = '请选择专业'
					this.popuptype = 'warning'
					issubmit = false
				} else if (this.classid == null || this.classid == '') {
					this.registermessage = '请选择班级'
					this.popuptype = 'warning'
					issubmit = false
				} else if (this.username == null || this.username == '') {
					this.registermessage = '请输入真实姓名'
					this.popuptype = 'warning'
					issubmit = false
				} else if (this.questionid == null || this.questionid == '') {
					this.registermessage = '请选择安全问题'
					this.popuptype = 'warning'
					issubmit = false
				} else if (this.questionanswer == null || this.questionanswer == '') {
					this.registermessage = '请输入安全问题答案'
					this.popuptype = 'warning'
					issubmit = false
				} else {
					this.registermessage = null
					issubmit = true
				}
				this.submitIn(issubmit)
			},
			submitIn(is){
				if(!is){
					this.$refs.popup.popupshow()
				}else{
					axios({
						method: 'post',
						url: this.$api.commonUrl + 'student/register',
						data: {
							name: this.username,  //姓名
							identifier: this.userno, //学号
							college: this.schoolid,  //学院
							major: this.majorid,  //专业
							className: this.classid,  //班级
							passWord: this.password1,  //密码
							questionId:this.questionid,  //安全问题id
							answer: this.questionanswer  //问题答案
						},
						responseType: "json"
					}).then(res => {
						if (res.data.code == '200') {
							this.isshowinsertbox = true
						}else{
							alert(res.data.message)
						}
					}).catch(err =>{
						console.log("insert", err)
					})
				}
			},
			backlogin() {
				this.$router.back()
			},
			getSchoollist() {
				axios({
					method: 'get',
					url: this.$api.commonUrl + 'college/major'
				}).then(res => {
					if (res.data.code == '200') {
						this.schoolList = res.data.data
					} else {
						console.log(res.data.message)
					}
				}).catch(err => {
					console.log("Schoollist", err)
				})
			},
			getQuestionlist() {
				axios({
					method: 'get',
					url: this.$api.commonUrl + 'question'
				}).then(res => {
					if (res.data.code == '200') {
						this.questionList = res.data.data
					} else {
						console.log(res.data.message)
					}
				}).catch(err => {
					console.log("Schoollist", err)
				})
			},
			Setschool() {
				this.majorList = this.schoolList.find((item, i) => {
					return item.id === this.schoolid
				})
			},
			Setmajor() {
				this.classList = this.majorList.children.find((item, i) => {
					return item.id === this.majorid
				})
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/style.css");

	.registeritem {
		position: absolute;
		z-index: 2;
		width: 100%;
		height: 100%;
	}

	.registeritem .registerbox {
		width: 32rem;
		height: 46rem;
		background: rgba(255, 255, 255, 0.5);
		position: absolute;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
		margin: auto;
	}

	.registeritem .registerbox_FF {
		position: absolute;
		top: 0.5rem;
		left: 0.5rem;
		right: 0.5rem;
		bottom: 0.5rem;
		background: #FFFFFF;
		z-index: 2;
	}

	.registeritem .registerbox_item {
		position: absolute;
		top: 0.5rem;
		left: 0.5rem;
		right: 0.5rem;
		bottom: 0.5rem;
		border: 1px solid #e5dbd1;
	}

	.registeritem .rebag {
		display: block;
		width: calc(100% - 2rem);
		height: auto;
		position: absolute;
		bottom: 1rem;
		left: 1rem;
		right: 1rem;
		z-index: 0;
	}

	.registeritem .title {
		font-size: 1.6rem;
		line-height: 2rem;
		height: 2rem;
		text-align: center;
		color: #a73a29;
		padding-top: 2rem;
		padding-bottom: 0.5rem;
	}

	.registeritem .item {
		width: calc(100% - 4rem);
		height: 2.8rem;
		margin-left: 2rem;
		margin-top: 1.5rem;
		border: 2px solid #a73a29;
	}

	.registeritem .itembtn {
		width: calc(100% - 4rem);
		height: auto;
		margin-left: 2rem;
		margin-top: 1.5rem;
		padding: 2px;
	}

	.registeritem .item input {
		width: calc(100% - 1.2rem);
		border: none;
		height: 2rem;
		margin: 0.2rem;
		padding: 0.2rem 0.4rem;
		line-height: 2rem;
		font-size: 1rem;
	}

	.registeritem .password2 {
		position: relative;
	}

	.registeritem .password2 input {
		width: calc(100% - 3.2rem);
	}

	.registeritem .password2 img {
		width: 2rem;
		height: 2rem;
		position: absolute;
		margin: auto;
		top: 0;
		bottom: 0;
	}

	.registeritem .items {
		width: calc(100% - 4rem);
		height: calc(2.8rem + 4px);
		margin-left: 2rem;
		margin-top: 1.5rem;
	}

	.registeritem .items .item2 {
		width: calc(50% - 1rem);
		border: 2px solid #a73a29;
		height: 2.8rem;
	}

	.registeritem .items .item2:first-child {
		float: left;
	}

	.registeritem .items .item2:last-child {
		float: right;
		margin-right: -4px;
	}

	.registeritem .items .item2 input {
		width: calc(100% - 1.2rem);
		border: none;
		height: 2rem;
		margin: 0.2rem;
		padding: 0.2rem 0.4rem;
		line-height: 2rem;
		font-size: 1rem;
	}

	.registeritem .itembtn button {
		width: 18rem;
		height: 3rem;
		border: none;
		background: #a73a29;
		color: #FFFFFF;
		font-size: 1rem;
	}

	.registeritem .item2 select {
		border: none;
		width: 100%;
		height: 100%;
		padding: 0.2rem 0.6rem;
	}

	.registeritem .item select {
		border: none;
		width: 100%;
		height: 100%;
		padding: 0.2rem 0.4rem;
	}

	.registeritem .itembtn a {
		float: right;
		line-height: 3rem;
		font-size: 1rem;
		color: #3e392e;
		padding-right: 1rem;
	}

	.registeritem .item2 {
		position: relative;
	}

	.registeritem .jt {
		position: absolute;
		width: 1rem;
		height: 1rem;
		margin: auto;
		top: 0px;
		bottom: 0px;
		right: 1rem;
	}

	.registeritem .item {
		position: relative;
	}
	@media screen and (max-width: 1680px) {
		html {
			font-size: 14px;
		}
	}
	
	@media screen and (max-width: 1600px) {
		html {
			font-size: 13px;
		}
	}
	
	@media screen and (max-width: 1440px) {
		html {
			font-size: 12px;
		}
	}
	
	@media screen and (max-width: 1400px) {
		html {
			font-size: 12px;
		}
	}
	
	@media screen and (max-width: 1366px) {
		html {
			font-size: 10px;
		}
	}
	
	@media screen and (max-width: 1360px) {
		html {
			font-size: 10px;
		}
	}
	
	@media screen and (max-width: 1280px) {
		html {
			font-size: 11px;
		}
	}
	
	@media screen and (max-width: 1152px) {
		html {
			font-size: 10px;
		}
	}
	
	@media screen and (max-width: 1024px) {
		html {
			font-size: 9px;
		}
	}
	
	@media screen and (max-width: 800px) {
		html {
			font-size: 8px;
		}
	}
	.popuptos{
		background: rgba(0,0,0,0.5);
		position: fixed;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
		z-index: 99;
	}
	.popuptos .popubox{
		position: absolute;
		width: 25rem;
		height: 19.5rem;
		background: #FFFFFF;
		margin: auto;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		border: 3px solid rgba(197,141,68,1);
	}
	.popuptos .poputitle{
		margin: 1px;
		height: 4rem;
		background: url(../../assets/images/tsbag.png) no-repeat 100%;
		color: #FFFFFF;
		font-size: 2rem;
		text-align: center;
		line-height: 4rem;
		font-family: 'STXingkai';
	}
	.popuptos .poputext{
		height: 7.5rem;
		text-align: center;
		padding: 2rem;
	}
	.popuptos .btna a{
		display: block;
		width: 8rem;
		height: 3rem;
		background: #a73a29;
		color: #FFFFFF;
		text-align: center;
		line-height: 3rem;
		font-size: 1.2rem;
		margin: 0px auto;
		text-decoration: none;
	}
	.popuptos .poputext{
		font-size: 1.2rem;
		color: #823d32;
		overflow: hidden;
	}
</style>
